module Meevo.Plugins.Register {
    "use strict";

    interface IClientSaleLineAmounts { clientSaleLineAmounts: { }; saleLinesTotal: number; count: number; }

    export class ClientPointsPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        private saleClientIds: string[] = [];
        clients: any[];
        totalReedemed: number = 0;
        totalObj: IClientSaleLineAmounts = null;
        nonClientPointPaymentsTotal: number = 0;
        pointsValue: number = this.registerContext.appSettings.APP_BUSINFOSETTINGS.clientPointSettings.pointsValue;
        dollarsValue: number = this.registerContext.appSettings.APP_BUSINFOSETTINGS.clientPointSettings.dollarsValue;

        get $timeout() { return this.registerContext.$timeout; }
        get $translate() { return this.registerContext.$translate; }
        get $filter() { return this.registerContext.$filter; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.ClientPoints,
                registerContext,
                "clientPointsPayments",
                Register.RegisterSectionCatTypeEnum.Payment);
        }

        private getClients() {
            if (_(this.saleClientIds).any()) {
                let request: any = {    
                    pageNumber: 0,
                    itemsPerPage: 1000,
                    criteria: {
                        clientIds: this.saleClientIds
                    }
                }
                this.dataService.getListPaged("clientpoint", request)
                    .then((clients: any) => {
                        for (var i = clients.length - 1; i >= 0; i--) {
                            var client = clients[i];
                            if (client.remainingAmount <= 0) {
                                clients.splice(i, 1);
                            } else {
                                client.amount = this.registerContext.getTotalPointsPayments(client.clientId);
                            }
                        }
                        this.clients = clients;
                        this.updateTotal();
                    });
            } else {
                this.clients = [];
                this.updateTotal();
            }
        }

        hasItems() {
            return this.clients && _(this.clients).any(x => x.remainingPoints > 0);
        }

        amountChanged(client) {
            if (client.amount > client.remainingAmount) {
                client.amount = client.remainingAmount;
            }

            const normalizedClientAmount = this.registerContext.roundingService.normalizeNumber(client.amount);
            const normalizedDollarsValue = this.registerContext.roundingService.normalizeNumber(this.dollarsValue);
            const greatestCommonDenominator = this.registerContext.roundingService.greatestCommonDenominator(this.pointsValue, normalizedDollarsValue);
            const redemptionIncrementDollarsValue = normalizedDollarsValue / greatestCommonDenominator;
            const normalizedAmount = Math.floor(normalizedClientAmount / redemptionIncrementDollarsValue) * redemptionIncrementDollarsValue;

            client.amount = this.registerContext.roundingService.denormalizeNumber(normalizedAmount);

            this.updateTotal();
        }

        public addPaymentDisabled() {
            return this.totalReedemed === 0;
        }

        private getTotalRedeemableAmount(): IClientSaleLineAmounts {
            let clientSaleLineAmounts = {};
            let saleLinesTotal: number = 0;
            let count: number = 0;

            this.registerContext.sale.saleLines.forEach((saleLine) => {
                let saleLineAmount: number = (saleLine.finalPriceCharge || 0) + ((saleLine.finalTax || 0) - (saleLine.finalTaxIncluded || 0));

                saleLinesTotal += saleLineAmount;
                if (saleLine.clientType == Model.ClientTypeEnum.Client) {
                    if (clientSaleLineAmounts[saleLine.clientId] == null) {
                        clientSaleLineAmounts[saleLine.clientId] = 0;
                        count++;
                    }
                    clientSaleLineAmounts[saleLine.clientId] += saleLineAmount;
                }
                else {
                    let clientTypeName = Model.ClientTypeEnum[saleLine.clientType];
                    if (clientSaleLineAmounts[clientTypeName] == null) {
                        clientSaleLineAmounts[clientTypeName] = 0;
                        count++;
                    }
                    clientSaleLineAmounts[clientTypeName] += saleLineAmount;
                }
            });

            return {
                saleLinesTotal: saleLinesTotal,
                clientSaleLineAmounts: clientSaleLineAmounts,
                count: count
            };
        }

        private getTotalNonPointsPayment(): number {
            let nonClientPointPaymentsTotal: number = 0;
            // get total payments that are not points
            this.registerContext.sale.paymentLines.forEach(paymentLine => {
                if (paymentLine.paymentCategory != Model.PaymentCategoryEnum.PointsRewards) {
                    nonClientPointPaymentsTotal += paymentLine.amount;
                }
            });
            return nonClientPointPaymentsTotal;
        }

        autoRedeem() {
            this.totalObj = this.getTotalRedeemableAmount();
            this.nonClientPointPaymentsTotal = this.getTotalNonPointsPayment();

            let clientSaleLineAmounts: {} = this.totalObj.clientSaleLineAmounts;
            let saleLinesTotal: number = this.totalObj.saleLinesTotal;
            let numUniqueClients: number = this.totalObj.count;
            let totalTipsDistributed: number = 0;
            let totalPaymentsDistributed: number = 0;
            let nonClientPointPaymentsTotal: number = this.nonClientPointPaymentsTotal;

            // Distribute payments proportionally across clients
            if (nonClientPointPaymentsTotal > 0) {
                let j: number = 0;
                for (var clientId in clientSaleLineAmounts) {
                    // The last client gets the remainder of payments to account for any rounding leftover
                    if (j == numUniqueClients - 1) {
                        clientSaleLineAmounts[clientId] -= (nonClientPointPaymentsTotal - totalPaymentsDistributed);
                    }
                    else {
                        let percentageOfSaleForClient: number = clientSaleLineAmounts[clientId] / saleLinesTotal;
                        let clientPaymentPortion: number = this.registerContext.roundingService.normalizeDecimalPlaces(nonClientPointPaymentsTotal * percentageOfSaleForClient);
                        totalPaymentsDistributed += clientPaymentPortion;
                        clientSaleLineAmounts[clientId] -= clientPaymentPortion;
                    }
                    j++;
                }
            }

            // use up client points
            for (let client of this.clients) {
                client.amount = 0;
                if (clientSaleLineAmounts[client.clientId] && clientSaleLineAmounts[client.clientId] > 0) {
                    client.amount = this.registerContext.roundingService.normalizeDecimalPlaces(Math.min(clientSaleLineAmounts[client.clientId], client.remainingAmount));
                    this.amountChanged(client);
                    clientSaleLineAmounts[client.clientId] -= client.amount;
                }
            }

            // use up remaining points on remaining balance of items
            let remainingAmount = this.registerContext.sale.tip + this.registerContext.sale.tipRefund + this.registerContext.sale.tipConvenienceFee + this.registerContext.sale.tipConvenienceFeeRefund;
            for (var clientId in clientSaleLineAmounts) {
                remainingAmount += clientSaleLineAmounts[clientId];
            }
            remainingAmount = this.registerContext.roundingService.normalizeDecimalPlaces(remainingAmount);
            for (let client of this.clients) {
                if (remainingAmount <= 0) {
                    break;
                }
                if (client.remainingAmount <= client.amount) {
                    continue;
                }
                const currentClientAmount = client.amount;
                client.amount = this.registerContext.roundingService.normalizeDecimalPlaces(client.amount + remainingAmount);
                this.amountChanged(client);
                remainingAmount = this.registerContext.roundingService.normalizeDecimalPlaces(remainingAmount - (client.amount - currentClientAmount));
            }

            this.updateTotal();
        }

        private updateTotal() {
            this.totalReedemed = 0;
            this.clients.forEach(client => {
                this.totalReedemed += parseFloat(client.amount);
            });
            this.updateMaxAmounts();
        }

        private updateMaxAmounts() {
            this.clients.forEach(client => {
                client.maxRedemptionAmount = this.maxRedemptionValue(client);
            });
        }

        private maxRedemptionValue(client): number {
            return Math.max(client.amount, Math.min(this.totalObj.saleLinesTotal - this.nonClientPointPaymentsTotal - this.totalReedemed, client.remainingAmount));
        }

        addPayment() {
            this.clients.forEach((client) => {
                if (client.amount > 0) {
                    let paymentType = _.findWhere(this.registerContext.paymentTypes, { paymentCategory: Model.PaymentCategoryEnum.PointsRewards });
                    let payment = {
                        __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentClientPoint, Millennium.Meevo.Register.Contracts.Model",
                        paymentTypeId: paymentType.id,
                        amount: parseFloat(client.amount),
                        clientDisplayName: client.displayName,
                        clientId: client.clientId,
                        paymentCategory: Model.PaymentCategoryEnum.PointsRewards
                    };
                    this.registerContext.addPayment(payment);
                }
            });

            this.registerContext.selectSection(RegisterSectionTypeEnum.PaymentOptions);
        }

        paymentLineRemoved(clientPointPayment: Model.SaleClientPointPayment) {
            let client = _(this.clients).findWhere({ clientId: clientPointPayment.clientId });
            if (client) {
                client.amount = 0;
                this.updateTotal();
            }
        }

        updateClients() {
            this.saleClientIds = _.chain(this.registerContext.allUniqueClients).where({ clientType: Model.ClientTypeEnum.Client }).map((item) => item.getId()).value();
            _(this.registerContext.clientFamilyMembers).each(client => {
                _(client.familyMembers).each(member => {
                    if (this.saleClientIds.indexOf(member.id) < 0) {
                        this.saleClientIds.push(member.id);
                    }
                });
            });
            this.getClients();
        }

        reset() {
            this.totalObj = this.getTotalRedeemableAmount();
            this.nonClientPointPaymentsTotal = this.getTotalNonPointsPayment();
            this.updateClients();
            let paymentType = _.findWhere(this.registerContext.paymentTypes, { paymentCategory: Model.PaymentCategoryEnum.PointsRewards });
            this.payment = {
                paymentTypeId: paymentType.id,
                amount: 0,
                paymentCategory: Model.PaymentCategoryEnum.PointsRewards
            };
        }
    }
}